import { Box, Typography, useTheme } from "@mui/material";
//import { AgGridReact } from 'ag-grid-react';
//import { ColDef } from 'ag-grid-community';
import { useMedia } from "react-use";

import { useNavigate } from "react-router-dom";
import { useProfile } from "api/hooks";

export const Privacy = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();

  const isSuperAdmin =
    profile?.roles?.some((role) => role.type === "SUPER_ADMIN") ?? false;
  const isAdmin =
    (profile?.roles?.some((role) => role.type === "ADMIN") || isSuperAdmin) ??
    false;

  const hasAccess = isAdmin || isSuperAdmin;

  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");
  const mobileFullWidth = "calc(100vw - 32px)";

  const theme = useTheme();
  const isWide = useMedia("(min-width: 768px)");

  return (
    <>
      <Box
        sx={{
          maxWidth: "768px",
          margin: "0 auto",
          pt: "16px",
        }}
      >
        <Typography gutterBottom variant="h4" component="div">
          Privacy Policy
        </Typography>
        <p>
          Protecting your privacy is important to us. This Privacy Policy
          explains how Spidipay Ltd. ("Spidipay", "we", "us" or "our") collects,
          uses, and shares your personal information when you use our payment
          services ("Services").
        </p>
        <h2>1. Information We Collect</h2>
        <p>
          We may collect the following types of personal information when you
          use our Services:
        </p>
        <ul>
          <li>
            Contact Information: such as your name, email address, phone number,
            and mailing address
          </li>
          <li>
            Payment Information: such as your credit card details or mobile
            money account information
          </li>
          <li>
            Transaction Information: such as the amount, date, and time of a
            transaction
          </li>
          <li>
            Device and Usage Information: such as your IP address, browser type,
            operating system, and website usage information
          </li>
          <li>
            Location Information: such as your device's GPS signal or
            information about nearby Wi-Fi access points
          </li>
          <li>
            Other Information: such as your preferences, feedback, and survey
            responses
          </li>
        </ul>
        <h2>2. How We Use Your Information</h2>
        <p>We may use your personal information to:</p>
        <ul>
          <li>Provide our Services and process transactions</li>
          <li>Verify your identity and prevent fraud</li>
          <li>Respond to your inquiries and provide customer support</li>
          {/*         
          <li>
            Communicate with you about our Services, promotions, and updates
          </li>
 */}
          <li>Conduct research and analyze trends to improve our Services</li>
          <li>
            Comply with legal obligations and enforce our Terms of Service
          </li>
        </ul>
        <h2>3. How We Share Your Information</h2>
        <p>
          We may share your personal information with the following types of
          third parties:
        </p>
        <ul>
          <li>
            Service Providers: We may share your personal information with
            third-party service providers who help us provide our Services, such
            as payment processors, fraud detection services, and customer
            support providers.
          </li>
          <li>
            Business Partners: We may share your personal information with our
            business partners who offer related services, credit card or mobile
            money providers.
          </li>
          <li>
            Legal Authorities: We may share your personal information if we are
            required to do so by law, or if we believe in good faith that such
            action is necessary to comply with legal obligations or protect the
            rights, property, or safety of Spidipay, our customers, or others.
          </li>
        </ul>
        <h2>4. Your Choices and Rights</h2>
        <p>
          You have certain choices and rights regarding your personal
          information. For example, you can:
        </p>
        <ul>
          <li>Update your account information and communication preferences</li>
          <li>Opt out of receiving marketing emails</li>
          <li>Access and request a copy of your personal information</li>
          <li>Request that we delete your personal information</li>
        </ul>
        <p>
          Please note that some of these choices and rights may be limited by
          legal obligations or other factors. To exercise your choices and
          rights, please contact us using the information in the "Contact Us"
          section below.
        </p>
        <h2>5. Security of Your Information</h2>
        <p>
          We take reasonable steps to protect your personal information from
          unauthorized access, disclosure, or misuse.
        </p>

        <p>International Data Transfers</p>
        <p>
          We may transfer your personal information outside of your country of
          residence. We will take appropriate measures to ensure that your
          personal information is protected in accordance with applicable laws.
        </p>

        <p>Children's Privacy</p>
        <p>
          Our Services are not intended for children under the age of 18, and we
          do not knowingly collect personal information from children under the
          age of 18.
        </p>

        <p>Changes to this Privacy Policy</p>
        <p>
          We may update this Privacy Policy from time to time by posting the
          updated policy on our website. Your continued use of our Services
          after such changes will constitute your acceptance of the new policy.
        </p>

        <p>Contact Us</p>
        <p>
          If you have any questions about this Privacy Policy or our handling of
          your personal information, please contact us.
        </p>

        <p>Thank you for using Spidipay's payment services!</p>
      </Box>
    </>
  );
};

export default Privacy;
